/**
 * GENERATED FILE — do not edit by hand.
 *
 * Timezone abbreviations frozen from moment-timezone 2.31.0
 * (tzdb 2026e) under 2026 rules: for every IANA zone,
 * [janAbbr, julAbbr] = what moment renders for the 'zz' token on
 * 2026-01-15T12:00:00Z / 2026-07-15T12:00:00Z. The date.ts zz-plugin selects the side whose
 * UTC offset matches the instance, so both hemispheres resolve DST correctly.
 *
 * Known two-side-model exceptions (a third intra-year abbreviation state under
 * 2026 rules — Alberta/BC/Manitoba permanent-time adoption in Nov 2026, Morocco/Western
 * Sahara Ramadan windows; the lookup renders the nearest probe side instead):
 * Africa/Casablanca, Africa/El_Aaiun, America/Edmonton, America/Inuvik, America/Rainy_River, America/Vancouver, America/Winnipeg, America/Yellowknife, Canada/Central, Canada/Mountain, Canada/Pacific.
 *
 * Regenerate: node scripts/generate-zone-abbreviations.mjs
 * (docker exec lula-foresight-app-fe node scripts/generate-zone-abbreviations.mjs)
 */
export const ZONE_ABBREVIATIONS: Readonly<Record<string, readonly [string, string]>> = {
  'Africa/Abidjan': ['GMT', 'GMT'],
  'Africa/Accra': ['GMT', 'GMT'],
  'Africa/Addis_Ababa': ['EAT', 'EAT'],
  'Africa/Algiers': ['CET', 'CET'],
  'Africa/Asmara': ['EAT', 'EAT'],
  'Africa/Asmera': ['EAT', 'EAT'],
  'Africa/Bamako': ['GMT', 'GMT'],
  'Africa/Bangui': ['WAT', 'WAT'],
  'Africa/Banjul': ['GMT', 'GMT'],
  'Africa/Bissau': ['GMT', 'GMT'],
  'Africa/Blantyre': ['CAT', 'CAT'],
  'Africa/Brazzaville': ['WAT', 'WAT'],
  'Africa/Bujumbura': ['CAT', 'CAT'],
  'Africa/Cairo': ['EET', 'EEST'],
  'Africa/Casablanca': ['+01', '+01'],
  'Africa/Ceuta': ['CET', 'CEST'],
  'Africa/Conakry': ['GMT', 'GMT'],
  'Africa/Dakar': ['GMT', 'GMT'],
  'Africa/Dar_es_Salaam': ['EAT', 'EAT'],
  'Africa/Djibouti': ['EAT', 'EAT'],
  'Africa/Douala': ['WAT', 'WAT'],
  'Africa/El_Aaiun': ['+01', '+01'],
  'Africa/Freetown': ['GMT', 'GMT'],
  'Africa/Gaborone': ['CAT', 'CAT'],
  'Africa/Harare': ['CAT', 'CAT'],
  'Africa/Johannesburg': ['SAST', 'SAST'],
  'Africa/Juba': ['CAT', 'CAT'],
  'Africa/Kampala': ['EAT', 'EAT'],
  'Africa/Khartoum': ['CAT', 'CAT'],
  'Africa/Kigali': ['CAT', 'CAT'],
  'Africa/Kinshasa': ['WAT', 'WAT'],
  'Africa/Lagos': ['WAT', 'WAT'],
  'Africa/Libreville': ['WAT', 'WAT'],
  'Africa/Lome': ['GMT', 'GMT'],
  'Africa/Luanda': ['WAT', 'WAT'],
  'Africa/Lubumbashi': ['CAT', 'CAT'],
  'Africa/Lusaka': ['CAT', 'CAT'],
  'Africa/Malabo': ['WAT', 'WAT'],
  'Africa/Maputo': ['CAT', 'CAT'],
  'Africa/Maseru': ['SAST', 'SAST'],
  'Africa/Mbabane': ['SAST', 'SAST'],
  'Africa/Mogadishu': ['EAT', 'EAT'],
  'Africa/Monrovia': ['GMT', 'GMT'],
  'Africa/Nairobi': ['EAT', 'EAT'],
  'Africa/Ndjamena': ['WAT', 'WAT'],
  'Africa/Niamey': ['WAT', 'WAT'],
  'Africa/Nouakchott': ['GMT', 'GMT'],
  'Africa/Ouagadougou': ['GMT', 'GMT'],
  'Africa/Porto-Novo': ['WAT', 'WAT'],
  'Africa/Sao_Tome': ['GMT', 'GMT'],
  'Africa/Timbuktu': ['GMT', 'GMT'],
  'Africa/Tripoli': ['EET', 'EET'],
  'Africa/Tunis': ['CET', 'CET'],
  'Africa/Windhoek': ['CAT', 'CAT'],
  'America/Adak': ['HST', 'HDT'],
  'America/Anchorage': ['AKST', 'AKDT'],
  'America/Anguilla': ['AST', 'AST'],
  'America/Antigua': ['AST', 'AST'],
  'America/Araguaina': ['-03', '-03'],
  'America/Argentina/Buenos_Aires': ['-03', '-03'],
  'America/Argentina/Catamarca': ['-03', '-03'],
  'America/Argentina/ComodRivadavia': ['-03', '-03'],
  'America/Argentina/Cordoba': ['-03', '-03'],
  'America/Argentina/Jujuy': ['-03', '-03'],
  'America/Argentina/La_Rioja': ['-03', '-03'],
  'America/Argentina/Mendoza': ['-03', '-03'],
  'America/Argentina/Rio_Gallegos': ['-03', '-03'],
  'America/Argentina/Salta': ['-03', '-03'],
  'America/Argentina/San_Juan': ['-03', '-03'],
  'America/Argentina/San_Luis': ['-03', '-03'],
  'America/Argentina/Tucuman': ['-03', '-03'],
  'America/Argentina/Ushuaia': ['-03', '-03'],
  'America/Aruba': ['AST', 'AST'],
  'America/Asuncion': ['-03', '-03'],
  'America/Atikokan': ['EST', 'EST'],
  'America/Atka': ['HST', 'HDT'],
  'America/Bahia': ['-03', '-03'],
  'America/Bahia_Banderas': ['CST', 'CST'],
  'America/Barbados': ['AST', 'AST'],
  'America/Belem': ['-03', '-03'],
  'America/Belize': ['CST', 'CST'],
  'America/Blanc-Sablon': ['AST', 'AST'],
  'America/Boa_Vista': ['-04', '-04'],
  'America/Bogota': ['-05', '-05'],
  'America/Boise': ['MST', 'MDT'],
  'America/Buenos_Aires': ['-03', '-03'],
  'America/Cambridge_Bay': ['MST', 'MDT'],
  'America/Campo_Grande': ['-04', '-04'],
  'America/Cancun': ['EST', 'EST'],
  'America/Caracas': ['-04', '-04'],
  'America/Catamarca': ['-03', '-03'],
  'America/Cayenne': ['-03', '-03'],
  'America/Cayman': ['EST', 'EST'],
  'America/Chicago': ['CST', 'CDT'],
  'America/Chihuahua': ['CST', 'CST'],
  'America/Ciudad_Juarez': ['MST', 'MDT'],
  'America/Coral_Harbour': ['EST', 'EST'],
  'America/Cordoba': ['-03', '-03'],
  'America/Costa_Rica': ['CST', 'CST'],
  'America/Coyhaique': ['-03', '-03'],
  'America/Creston': ['MST', 'MST'],
  'America/Cuiaba': ['-04', '-04'],
  'America/Curacao': ['AST', 'AST'],
  'America/Danmarkshavn': ['GMT', 'GMT'],
  'America/Dawson': ['MST', 'MST'],
  'America/Dawson_Creek': ['MST', 'MST'],
  'America/Denver': ['MST', 'MDT'],
  'America/Detroit': ['EST', 'EDT'],
  'America/Dominica': ['AST', 'AST'],
  'America/Edmonton': ['MST', 'MDT'],
  'America/Eirunepe': ['-05', '-05'],
  'America/El_Salvador': ['CST', 'CST'],
  'America/Ensenada': ['PST', 'PDT'],
  'America/Fort_Nelson': ['MST', 'MST'],
  'America/Fort_Wayne': ['EST', 'EDT'],
  'America/Fortaleza': ['-03', '-03'],
  'America/Glace_Bay': ['AST', 'ADT'],
  'America/Godthab': ['-02', '-01'],
  'America/Goose_Bay': ['AST', 'ADT'],
  'America/Grand_Turk': ['EST', 'EDT'],
  'America/Grenada': ['AST', 'AST'],
  'America/Guadeloupe': ['AST', 'AST'],
  'America/Guatemala': ['CST', 'CST'],
  'America/Guayaquil': ['-05', '-05'],
  'America/Guyana': ['-04', '-04'],
  'America/Halifax': ['AST', 'ADT'],
  'America/Havana': ['CST', 'CDT'],
  'America/Hermosillo': ['MST', 'MST'],
  'America/Indiana/Indianapolis': ['EST', 'EDT'],
  'America/Indiana/Knox': ['CST', 'CDT'],
  'America/Indiana/Marengo': ['EST', 'EDT'],
  'America/Indiana/Petersburg': ['EST', 'EDT'],
  'America/Indiana/Tell_City': ['CST', 'CDT'],
  'America/Indiana/Vevay': ['EST', 'EDT'],
  'America/Indiana/Vincennes': ['EST', 'EDT'],
  'America/Indiana/Winamac': ['EST', 'EDT'],
  'America/Indianapolis': ['EST', 'EDT'],
  'America/Inuvik': ['MST', 'MDT'],
  'America/Iqaluit': ['EST', 'EDT'],
  'America/Jamaica': ['EST', 'EST'],
  'America/Jujuy': ['-03', '-03'],
  'America/Juneau': ['AKST', 'AKDT'],
  'America/Kentucky/Louisville': ['EST', 'EDT'],
  'America/Kentucky/Monticello': ['EST', 'EDT'],
  'America/Knox_IN': ['CST', 'CDT'],
  'America/Kralendijk': ['AST', 'AST'],
  'America/La_Paz': ['-04', '-04'],
  'America/Lima': ['-05', '-05'],
  'America/Los_Angeles': ['PST', 'PDT'],
  'America/Louisville': ['EST', 'EDT'],
  'America/Lower_Princes': ['AST', 'AST'],
  'America/Maceio': ['-03', '-03'],
  'America/Managua': ['CST', 'CST'],
  'America/Manaus': ['-04', '-04'],
  'America/Marigot': ['AST', 'AST'],
  'America/Martinique': ['AST', 'AST'],
  'America/Matamoros': ['CST', 'CDT'],
  'America/Mazatlan': ['MST', 'MST'],
  'America/Mendoza': ['-03', '-03'],
  'America/Menominee': ['CST', 'CDT'],
  'America/Merida': ['CST', 'CST'],
  'America/Metlakatla': ['AKST', 'AKDT'],
  'America/Mexico_City': ['CST', 'CST'],
  'America/Miquelon': ['-03', '-02'],
  'America/Moncton': ['AST', 'ADT'],
  'America/Monterrey': ['CST', 'CST'],
  'America/Montevideo': ['-03', '-03'],
  'America/Montreal': ['EST', 'EDT'],
  'America/Montserrat': ['AST', 'AST'],
  'America/Nassau': ['EST', 'EDT'],
  'America/New_York': ['EST', 'EDT'],
  'America/Nipigon': ['EST', 'EDT'],
  'America/Nome': ['AKST', 'AKDT'],
  'America/Noronha': ['-02', '-02'],
  'America/North_Dakota/Beulah': ['CST', 'CDT'],
  'America/North_Dakota/Center': ['CST', 'CDT'],
  'America/North_Dakota/New_Salem': ['CST', 'CDT'],
  'America/Nuuk': ['-02', '-01'],
  'America/Ojinaga': ['CST', 'CDT'],
  'America/Panama': ['EST', 'EST'],
  'America/Pangnirtung': ['EST', 'EDT'],
  'America/Paramaribo': ['-03', '-03'],
  'America/Phoenix': ['MST', 'MST'],
  'America/Port-au-Prince': ['EST', 'EDT'],
  'America/Port_of_Spain': ['AST', 'AST'],
  'America/Porto_Acre': ['-05', '-05'],
  'America/Porto_Velho': ['-04', '-04'],
  'America/Puerto_Rico': ['AST', 'AST'],
  'America/Punta_Arenas': ['-03', '-03'],
  'America/Rainy_River': ['CST', 'CDT'],
  'America/Rankin_Inlet': ['CST', 'CDT'],
  'America/Recife': ['-03', '-03'],
  'America/Regina': ['CST', 'CST'],
  'America/Resolute': ['CST', 'CDT'],
  'America/Rio_Branco': ['-05', '-05'],
  'America/Rosario': ['-03', '-03'],
  'America/Santa_Isabel': ['PST', 'PDT'],
  'America/Santarem': ['-03', '-03'],
  'America/Santiago': ['-03', '-04'],
  'America/Santo_Domingo': ['AST', 'AST'],
  'America/Sao_Paulo': ['-03', '-03'],
  'America/Scoresbysund': ['-02', '-01'],
  'America/Shiprock': ['MST', 'MDT'],
  'America/Sitka': ['AKST', 'AKDT'],
  'America/St_Barthelemy': ['AST', 'AST'],
  'America/St_Johns': ['NST', 'NDT'],
  'America/St_Kitts': ['AST', 'AST'],
  'America/St_Lucia': ['AST', 'AST'],
  'America/St_Thomas': ['AST', 'AST'],
  'America/St_Vincent': ['AST', 'AST'],
  'America/Swift_Current': ['CST', 'CST'],
  'America/Tegucigalpa': ['CST', 'CST'],
  'America/Thule': ['AST', 'ADT'],
  'America/Thunder_Bay': ['EST', 'EDT'],
  'America/Tijuana': ['PST', 'PDT'],
  'America/Toronto': ['EST', 'EDT'],
  'America/Tortola': ['AST', 'AST'],
  'America/Vancouver': ['PST', 'PDT'],
  'America/Virgin': ['AST', 'AST'],
  'America/Whitehorse': ['MST', 'MST'],
  'America/Winnipeg': ['CST', 'CDT'],
  'America/Yakutat': ['AKST', 'AKDT'],
  'America/Yellowknife': ['MST', 'MDT'],
  'Antarctica/Casey': ['+08', '+08'],
  'Antarctica/Davis': ['+07', '+07'],
  'Antarctica/DumontDUrville': ['+10', '+10'],
  'Antarctica/Macquarie': ['AEDT', 'AEST'],
  'Antarctica/Mawson': ['+05', '+05'],
  'Antarctica/McMurdo': ['NZDT', 'NZST'],
  'Antarctica/Palmer': ['-03', '-03'],
  'Antarctica/Rothera': ['-03', '-03'],
  'Antarctica/South_Pole': ['NZDT', 'NZST'],
  'Antarctica/Syowa': ['+03', '+03'],
  'Antarctica/Troll': ['+00', '+02'],
  'Antarctica/Vostok': ['+05', '+05'],
  'Arctic/Longyearbyen': ['CET', 'CEST'],
  'Asia/Aden': ['+03', '+03'],
  'Asia/Almaty': ['+05', '+05'],
  'Asia/Amman': ['+03', '+03'],
  'Asia/Anadyr': ['+12', '+12'],
  'Asia/Aqtau': ['+05', '+05'],
  'Asia/Aqtobe': ['+05', '+05'],
  'Asia/Ashgabat': ['+05', '+05'],
  'Asia/Ashkhabad': ['+05', '+05'],
  'Asia/Atyrau': ['+05', '+05'],
  'Asia/Baghdad': ['+03', '+03'],
  'Asia/Bahrain': ['+03', '+03'],
  'Asia/Baku': ['+04', '+04'],
  'Asia/Bangkok': ['+07', '+07'],
  'Asia/Barnaul': ['+07', '+07'],
  'Asia/Beirut': ['EET', 'EEST'],
  'Asia/Bishkek': ['+06', '+06'],
  'Asia/Brunei': ['+08', '+08'],
  'Asia/Calcutta': ['IST', 'IST'],
  'Asia/Chita': ['+09', '+09'],
  'Asia/Choibalsan': ['+08', '+08'],
  'Asia/Chongqing': ['CST', 'CST'],
  'Asia/Chungking': ['CST', 'CST'],
  'Asia/Colombo': ['+0530', '+0530'],
  'Asia/Dacca': ['+06', '+06'],
  'Asia/Damascus': ['+03', '+03'],
  'Asia/Dhaka': ['+06', '+06'],
  'Asia/Dili': ['+09', '+09'],
  'Asia/Dubai': ['+04', '+04'],
  'Asia/Dushanbe': ['+05', '+05'],
  'Asia/Famagusta': ['EET', 'EEST'],
  'Asia/Gaza': ['EET', 'EEST'],
  'Asia/Harbin': ['CST', 'CST'],
  'Asia/Hebron': ['EET', 'EEST'],
  'Asia/Ho_Chi_Minh': ['+07', '+07'],
  'Asia/Hong_Kong': ['HKT', 'HKT'],
  'Asia/Hovd': ['+07', '+07'],
  'Asia/Irkutsk': ['+08', '+08'],
  'Asia/Istanbul': ['+03', '+03'],
  'Asia/Jakarta': ['WIB', 'WIB'],
  'Asia/Jayapura': ['WIT', 'WIT'],
  'Asia/Jerusalem': ['IST', 'IDT'],
  'Asia/Kabul': ['+0430', '+0430'],
  'Asia/Kamchatka': ['+12', '+12'],
  'Asia/Karachi': ['PKT', 'PKT'],
  'Asia/Kashgar': ['+06', '+06'],
  'Asia/Kathmandu': ['+0545', '+0545'],
  'Asia/Katmandu': ['+0545', '+0545'],
  'Asia/Khandyga': ['+09', '+09'],
  'Asia/Kolkata': ['IST', 'IST'],
  'Asia/Krasnoyarsk': ['+07', '+07'],
  'Asia/Kuala_Lumpur': ['+08', '+08'],
  'Asia/Kuching': ['+08', '+08'],
  'Asia/Kuwait': ['+03', '+03'],
  'Asia/Macao': ['CST', 'CST'],
  'Asia/Macau': ['CST', 'CST'],
  'Asia/Magadan': ['+11', '+11'],
  'Asia/Makassar': ['WITA', 'WITA'],
  'Asia/Manila': ['PST', 'PST'],
  'Asia/Muscat': ['+04', '+04'],
  'Asia/Nicosia': ['EET', 'EEST'],
  'Asia/Novokuznetsk': ['+07', '+07'],
  'Asia/Novosibirsk': ['+07', '+07'],
  'Asia/Omsk': ['+06', '+06'],
  'Asia/Oral': ['+05', '+05'],
  'Asia/Phnom_Penh': ['+07', '+07'],
  'Asia/Pontianak': ['WIB', 'WIB'],
  'Asia/Pyongyang': ['KST', 'KST'],
  'Asia/Qatar': ['+03', '+03'],
  'Asia/Qostanay': ['+05', '+05'],
  'Asia/Qyzylorda': ['+05', '+05'],
  'Asia/Rangoon': ['+0630', '+0630'],
  'Asia/Riyadh': ['+03', '+03'],
  'Asia/Saigon': ['+07', '+07'],
  'Asia/Sakhalin': ['+11', '+11'],
  'Asia/Samarkand': ['+05', '+05'],
  'Asia/Seoul': ['KST', 'KST'],
  'Asia/Shanghai': ['CST', 'CST'],
  'Asia/Singapore': ['+08', '+08'],
  'Asia/Srednekolymsk': ['+11', '+11'],
  'Asia/Taipei': ['CST', 'CST'],
  'Asia/Tashkent': ['+05', '+05'],
  'Asia/Tbilisi': ['+04', '+04'],
  'Asia/Tehran': ['+0330', '+0330'],
  'Asia/Tel_Aviv': ['IST', 'IDT'],
  'Asia/Thimbu': ['+06', '+06'],
  'Asia/Thimphu': ['+06', '+06'],
  'Asia/Tokyo': ['JST', 'JST'],
  'Asia/Tomsk': ['+07', '+07'],
  'Asia/Ujung_Pandang': ['WITA', 'WITA'],
  'Asia/Ulaanbaatar': ['+08', '+08'],
  'Asia/Ulan_Bator': ['+08', '+08'],
  'Asia/Urumqi': ['+06', '+06'],
  'Asia/Ust-Nera': ['+10', '+10'],
  'Asia/Vientiane': ['+07', '+07'],
  'Asia/Vladivostok': ['+10', '+10'],
  'Asia/Yakutsk': ['+09', '+09'],
  'Asia/Yangon': ['+0630', '+0630'],
  'Asia/Yekaterinburg': ['+05', '+05'],
  'Asia/Yerevan': ['+04', '+04'],
  'Atlantic/Azores': ['-01', '+00'],
  'Atlantic/Bermuda': ['AST', 'ADT'],
  'Atlantic/Canary': ['WET', 'WEST'],
  'Atlantic/Cape_Verde': ['-01', '-01'],
  'Atlantic/Faeroe': ['WET', 'WEST'],
  'Atlantic/Faroe': ['WET', 'WEST'],
  'Atlantic/Jan_Mayen': ['CET', 'CEST'],
  'Atlantic/Madeira': ['WET', 'WEST'],
  'Atlantic/Reykjavik': ['GMT', 'GMT'],
  'Atlantic/South_Georgia': ['-02', '-02'],
  'Atlantic/St_Helena': ['GMT', 'GMT'],
  'Atlantic/Stanley': ['-03', '-03'],
  'Australia/ACT': ['AEDT', 'AEST'],
  'Australia/Adelaide': ['ACDT', 'ACST'],
  'Australia/Brisbane': ['AEST', 'AEST'],
  'Australia/Broken_Hill': ['ACDT', 'ACST'],
  'Australia/Canberra': ['AEDT', 'AEST'],
  'Australia/Currie': ['AEDT', 'AEST'],
  'Australia/Darwin': ['ACST', 'ACST'],
  'Australia/Eucla': ['+0845', '+0845'],
  'Australia/Hobart': ['AEDT', 'AEST'],
  'Australia/LHI': ['+11', '+1030'],
  'Australia/Lindeman': ['AEST', 'AEST'],
  'Australia/Lord_Howe': ['+11', '+1030'],
  'Australia/Melbourne': ['AEDT', 'AEST'],
  'Australia/NSW': ['AEDT', 'AEST'],
  'Australia/North': ['ACST', 'ACST'],
  'Australia/Perth': ['AWST', 'AWST'],
  'Australia/Queensland': ['AEST', 'AEST'],
  'Australia/South': ['ACDT', 'ACST'],
  'Australia/Sydney': ['AEDT', 'AEST'],
  'Australia/Tasmania': ['AEDT', 'AEST'],
  'Australia/Victoria': ['AEDT', 'AEST'],
  'Australia/West': ['AWST', 'AWST'],
  'Australia/Yancowinna': ['ACDT', 'ACST'],
  'Brazil/Acre': ['-05', '-05'],
  'Brazil/DeNoronha': ['-02', '-02'],
  'Brazil/East': ['-03', '-03'],
  'Brazil/West': ['-04', '-04'],
  CET: ['CET', 'CEST'],
  CST6CDT: ['CST', 'CDT'],
  'Canada/Atlantic': ['AST', 'ADT'],
  'Canada/Central': ['CST', 'CDT'],
  'Canada/Eastern': ['EST', 'EDT'],
  'Canada/Mountain': ['MST', 'MDT'],
  'Canada/Newfoundland': ['NST', 'NDT'],
  'Canada/Pacific': ['PST', 'PDT'],
  'Canada/Saskatchewan': ['CST', 'CST'],
  'Canada/Yukon': ['MST', 'MST'],
  'Chile/Continental': ['-03', '-04'],
  'Chile/EasterIsland': ['-05', '-06'],
  Cuba: ['CST', 'CDT'],
  EET: ['EET', 'EEST'],
  EST: ['EST', 'EST'],
  EST5EDT: ['EST', 'EDT'],
  Egypt: ['EET', 'EEST'],
  Eire: ['GMT', 'IST'],
  'Etc/GMT': ['GMT', 'GMT'],
  'Etc/GMT+0': ['GMT', 'GMT'],
  'Etc/GMT+1': ['-01', '-01'],
  'Etc/GMT+10': ['-10', '-10'],
  'Etc/GMT+11': ['-11', '-11'],
  'Etc/GMT+12': ['-12', '-12'],
  'Etc/GMT+2': ['-02', '-02'],
  'Etc/GMT+3': ['-03', '-03'],
  'Etc/GMT+4': ['-04', '-04'],
  'Etc/GMT+5': ['-05', '-05'],
  'Etc/GMT+6': ['-06', '-06'],
  'Etc/GMT+7': ['-07', '-07'],
  'Etc/GMT+8': ['-08', '-08'],
  'Etc/GMT+9': ['-09', '-09'],
  'Etc/GMT-0': ['GMT', 'GMT'],
  'Etc/GMT-1': ['+01', '+01'],
  'Etc/GMT-10': ['+10', '+10'],
  'Etc/GMT-11': ['+11', '+11'],
  'Etc/GMT-12': ['+12', '+12'],
  'Etc/GMT-13': ['+13', '+13'],
  'Etc/GMT-14': ['+14', '+14'],
  'Etc/GMT-2': ['+02', '+02'],
  'Etc/GMT-3': ['+03', '+03'],
  'Etc/GMT-4': ['+04', '+04'],
  'Etc/GMT-5': ['+05', '+05'],
  'Etc/GMT-6': ['+06', '+06'],
  'Etc/GMT-7': ['+07', '+07'],
  'Etc/GMT-8': ['+08', '+08'],
  'Etc/GMT-9': ['+09', '+09'],
  'Etc/GMT0': ['GMT', 'GMT'],
  'Etc/Greenwich': ['GMT', 'GMT'],
  'Etc/UCT': ['UTC', 'UTC'],
  'Etc/UTC': ['UTC', 'UTC'],
  'Etc/Universal': ['UTC', 'UTC'],
  'Etc/Zulu': ['UTC', 'UTC'],
  'Europe/Amsterdam': ['CET', 'CEST'],
  'Europe/Andorra': ['CET', 'CEST'],
  'Europe/Astrakhan': ['+04', '+04'],
  'Europe/Athens': ['EET', 'EEST'],
  'Europe/Belfast': ['GMT', 'BST'],
  'Europe/Belgrade': ['CET', 'CEST'],
  'Europe/Berlin': ['CET', 'CEST'],
  'Europe/Bratislava': ['CET', 'CEST'],
  'Europe/Brussels': ['CET', 'CEST'],
  'Europe/Bucharest': ['EET', 'EEST'],
  'Europe/Budapest': ['CET', 'CEST'],
  'Europe/Busingen': ['CET', 'CEST'],
  'Europe/Chisinau': ['EET', 'EEST'],
  'Europe/Copenhagen': ['CET', 'CEST'],
  'Europe/Dublin': ['GMT', 'IST'],
  'Europe/Gibraltar': ['CET', 'CEST'],
  'Europe/Guernsey': ['GMT', 'BST'],
  'Europe/Helsinki': ['EET', 'EEST'],
  'Europe/Isle_of_Man': ['GMT', 'BST'],
  'Europe/Istanbul': ['+03', '+03'],
  'Europe/Jersey': ['GMT', 'BST'],
  'Europe/Kaliningrad': ['EET', 'EET'],
  'Europe/Kiev': ['EET', 'EEST'],
  'Europe/Kirov': ['MSK', 'MSK'],
  'Europe/Kyiv': ['EET', 'EEST'],
  'Europe/Lisbon': ['WET', 'WEST'],
  'Europe/Ljubljana': ['CET', 'CEST'],
  'Europe/London': ['GMT', 'BST'],
  'Europe/Luxembourg': ['CET', 'CEST'],
  'Europe/Madrid': ['CET', 'CEST'],
  'Europe/Malta': ['CET', 'CEST'],
  'Europe/Mariehamn': ['EET', 'EEST'],
  'Europe/Minsk': ['+03', '+03'],
  'Europe/Monaco': ['CET', 'CEST'],
  'Europe/Moscow': ['MSK', 'MSK'],
  'Europe/Nicosia': ['EET', 'EEST'],
  'Europe/Oslo': ['CET', 'CEST'],
  'Europe/Paris': ['CET', 'CEST'],
  'Europe/Podgorica': ['CET', 'CEST'],
  'Europe/Prague': ['CET', 'CEST'],
  'Europe/Riga': ['EET', 'EEST'],
  'Europe/Rome': ['CET', 'CEST'],
  'Europe/Samara': ['+04', '+04'],
  'Europe/San_Marino': ['CET', 'CEST'],
  'Europe/Sarajevo': ['CET', 'CEST'],
  'Europe/Saratov': ['+04', '+04'],
  'Europe/Simferopol': ['MSK', 'MSK'],
  'Europe/Skopje': ['CET', 'CEST'],
  'Europe/Sofia': ['EET', 'EEST'],
  'Europe/Stockholm': ['CET', 'CEST'],
  'Europe/Tallinn': ['EET', 'EEST'],
  'Europe/Tirane': ['CET', 'CEST'],
  'Europe/Tiraspol': ['EET', 'EEST'],
  'Europe/Ulyanovsk': ['+04', '+04'],
  'Europe/Uzhgorod': ['EET', 'EEST'],
  'Europe/Vaduz': ['CET', 'CEST'],
  'Europe/Vatican': ['CET', 'CEST'],
  'Europe/Vienna': ['CET', 'CEST'],
  'Europe/Vilnius': ['EET', 'EEST'],
  'Europe/Volgograd': ['MSK', 'MSK'],
  'Europe/Warsaw': ['CET', 'CEST'],
  'Europe/Zagreb': ['CET', 'CEST'],
  'Europe/Zaporozhye': ['EET', 'EEST'],
  'Europe/Zurich': ['CET', 'CEST'],
  GB: ['GMT', 'BST'],
  'GB-Eire': ['GMT', 'BST'],
  GMT: ['GMT', 'GMT'],
  'GMT+0': ['GMT', 'GMT'],
  'GMT-0': ['GMT', 'GMT'],
  GMT0: ['GMT', 'GMT'],
  Greenwich: ['GMT', 'GMT'],
  HST: ['HST', 'HST'],
  Hongkong: ['HKT', 'HKT'],
  Iceland: ['GMT', 'GMT'],
  'Indian/Antananarivo': ['EAT', 'EAT'],
  'Indian/Chagos': ['+06', '+06'],
  'Indian/Christmas': ['+07', '+07'],
  'Indian/Cocos': ['+0630', '+0630'],
  'Indian/Comoro': ['EAT', 'EAT'],
  'Indian/Kerguelen': ['+05', '+05'],
  'Indian/Mahe': ['+04', '+04'],
  'Indian/Maldives': ['+05', '+05'],
  'Indian/Mauritius': ['+04', '+04'],
  'Indian/Mayotte': ['EAT', 'EAT'],
  'Indian/Reunion': ['+04', '+04'],
  Iran: ['+0330', '+0330'],
  Israel: ['IST', 'IDT'],
  Jamaica: ['EST', 'EST'],
  Japan: ['JST', 'JST'],
  Kwajalein: ['+12', '+12'],
  Libya: ['EET', 'EET'],
  MET: ['CET', 'CEST'],
  MST: ['MST', 'MST'],
  MST7MDT: ['MST', 'MDT'],
  'Mexico/BajaNorte': ['PST', 'PDT'],
  'Mexico/BajaSur': ['MST', 'MST'],
  'Mexico/General': ['CST', 'CST'],
  NZ: ['NZDT', 'NZST'],
  'NZ-CHAT': ['+1345', '+1245'],
  Navajo: ['MST', 'MDT'],
  PRC: ['CST', 'CST'],
  PST8PDT: ['PST', 'PDT'],
  'Pacific/Apia': ['+13', '+13'],
  'Pacific/Auckland': ['NZDT', 'NZST'],
  'Pacific/Bougainville': ['+11', '+11'],
  'Pacific/Chatham': ['+1345', '+1245'],
  'Pacific/Chuuk': ['+10', '+10'],
  'Pacific/Easter': ['-05', '-06'],
  'Pacific/Efate': ['+11', '+11'],
  'Pacific/Enderbury': ['+13', '+13'],
  'Pacific/Fakaofo': ['+13', '+13'],
  'Pacific/Fiji': ['+12', '+12'],
  'Pacific/Funafuti': ['+12', '+12'],
  'Pacific/Galapagos': ['-06', '-06'],
  'Pacific/Gambier': ['-09', '-09'],
  'Pacific/Guadalcanal': ['+11', '+11'],
  'Pacific/Guam': ['ChST', 'ChST'],
  'Pacific/Honolulu': ['HST', 'HST'],
  'Pacific/Johnston': ['HST', 'HST'],
  'Pacific/Kanton': ['+13', '+13'],
  'Pacific/Kiritimati': ['+14', '+14'],
  'Pacific/Kosrae': ['+11', '+11'],
  'Pacific/Kwajalein': ['+12', '+12'],
  'Pacific/Majuro': ['+12', '+12'],
  'Pacific/Marquesas': ['-0930', '-0930'],
  'Pacific/Midway': ['SST', 'SST'],
  'Pacific/Nauru': ['+12', '+12'],
  'Pacific/Niue': ['-11', '-11'],
  'Pacific/Norfolk': ['+12', '+11'],
  'Pacific/Noumea': ['+11', '+11'],
  'Pacific/Pago_Pago': ['SST', 'SST'],
  'Pacific/Palau': ['+09', '+09'],
  'Pacific/Pitcairn': ['-08', '-08'],
  'Pacific/Pohnpei': ['+11', '+11'],
  'Pacific/Ponape': ['+11', '+11'],
  'Pacific/Port_Moresby': ['+10', '+10'],
  'Pacific/Rarotonga': ['-10', '-10'],
  'Pacific/Saipan': ['ChST', 'ChST'],
  'Pacific/Samoa': ['SST', 'SST'],
  'Pacific/Tahiti': ['-10', '-10'],
  'Pacific/Tarawa': ['+12', '+12'],
  'Pacific/Tongatapu': ['+13', '+13'],
  'Pacific/Truk': ['+10', '+10'],
  'Pacific/Wake': ['+12', '+12'],
  'Pacific/Wallis': ['+12', '+12'],
  'Pacific/Yap': ['+10', '+10'],
  Poland: ['CET', 'CEST'],
  Portugal: ['WET', 'WEST'],
  ROC: ['CST', 'CST'],
  ROK: ['KST', 'KST'],
  Singapore: ['+08', '+08'],
  Turkey: ['+03', '+03'],
  UCT: ['UTC', 'UTC'],
  'US/Alaska': ['AKST', 'AKDT'],
  'US/Aleutian': ['HST', 'HDT'],
  'US/Arizona': ['MST', 'MST'],
  'US/Central': ['CST', 'CDT'],
  'US/East-Indiana': ['EST', 'EDT'],
  'US/Eastern': ['EST', 'EDT'],
  'US/Hawaii': ['HST', 'HST'],
  'US/Indiana-Starke': ['CST', 'CDT'],
  'US/Michigan': ['EST', 'EDT'],
  'US/Mountain': ['MST', 'MDT'],
  'US/Pacific': ['PST', 'PDT'],
  'US/Samoa': ['SST', 'SST'],
  UTC: ['UTC', 'UTC'],
  Universal: ['UTC', 'UTC'],
  'W-SU': ['MSK', 'MSK'],
  WET: ['WET', 'WEST'],
  Zulu: ['UTC', 'UTC'],
};
